import React, { createContext, useState } from 'react';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const SelectionsMeetEventsStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
};

const SelectionsMeetEventsContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <SelectionsMeetEventsStateContext.Provider value={stateHook}>
      {children}
    </SelectionsMeetEventsStateContext.Provider>
  );
};

export default SelectionsMeetEventsContextProvider;